import React from 'react';
import Head from 'next/head';
import PropTypes from 'prop-types';
import NextSeo from 'next-seo';

import ProductContainer from '@features/products/pages/Product/containers/Product';
import * as entityActions from '@store/entity/actions';
import { entitySelectors } from '@store/entity/selectors';
import { analytics } from '@features/analytics';
import { ComingSoonBanner } from '@common/components/ComingSoonBanner';
class ProductPage extends React.Component {
  static async getInitialProps({ store, property, language, query, url }) {
    await store.dispatch(entityActions.fetchProduct(property.id, query.id, language));

    const product = entitySelectors.getProduct(store.getState(), query.id);
    return {
      id: query.id,
      property,
      language,
      product,
      url,
      socialFallbackImage: property.socialFallbackImage,
      isComingSoonEnabled: property.isComingSoonEnabled,
    };
  }

  componentDidMount() {
    const { product } = this.props;

    analytics.track({
      event: 'view_item',
      params: {
        currency: product.price.currencyCode,
        value: product.price.amount,
        items: [{ item_category: 'products', item_id: `${product.id}`, item_name: product.name }],
      },
    });
  }

  render() {
    const { id, property, language, product, socialFallbackImage, url, isComingSoonEnabled } =
      this.props;

    const pageTitle = property.propertyTitle
      ? `${product.name} | ${property.propertyTitle}`
      : product.name;

    return (
      <>
        <Head>
          <title>{pageTitle}</title>
        </Head>
        <NextSeo
          config={{
            openGraph: {
              title: pageTitle,
              description: product.summaryDescription,
              locale: language,
              url,
              images: [
                {
                  url:
                    product.imageGallery && product.imageGallery.length
                      ? product.imageGallery[0].url
                      : socialFallbackImage && socialFallbackImage.url,
                },
              ],
            },
          }}
        />
        {isComingSoonEnabled && <ComingSoonBanner />}
        <ProductContainer id={id} key={id} property={property} language={language} />
      </>
    );
  }
}

ProductPage.propTypes = {
  id: PropTypes.string.isRequired,
  property: PropTypes.object.isRequired,
  language: PropTypes.string.isRequired,
  socialFallbackImage: PropTypes.shape({
    url: PropTypes.string,
  }),
  product: PropTypes.object.isRequired,
  isComingSoonEnabled: PropTypes.bool,
  url: PropTypes.string.isRequired,
};

ProductPage.defaultProps = {
  socialFallbackImage: { url: '' },
  isComingSoonEnabled: false,
};

export default ProductPage;
